export default {
  question: {
    label: 'questionen',
    changeButton: 'change the secret question',
    titleChangeDialog: 'Change Secret question',
    changeDialog: {
      label: 'Secret question',
      response: 'Answer',
    },
  },
}
